import React, { useState, useEffect } from 'react'
import { Table } from 'antd'
import MapWithAMarker from './map'
import { Redirect } from 'react-router'
import Enquiry from './ClientEnquiry'
import * as columns from './columns'

const Home = ({ user, posts, QualityPlans }) => {
  const [postData, setPostData] = useState([])
  const [data, setData] = useState([])

  const clientEnquiry = () =>
    user && user.role === 'admin' && <Enquiry QualityPlans={QualityPlans} selectedEnquiry={val => console.log(val)} />

  useEffect(() => {
    if (posts) {
      let job = post => post.form_values.ec4e + ' | ' + post.form_values['762b']
      if (user.role === 'admin') {
        setPostData(posts.map(p => ({ ...p, job: job(p) })))
      } else if (user.role === 'client') {
        setPostData(
          posts.map(p => p.form_values.d149 === user.username && { ...p, job: job(p) }).filter(i => i !== false)
        )
      }
    }
  }, [posts])

  const checkData = () => postData.length === 0

  useEffect(() => {
    var oneYear = new Date()
    oneYear.setDate(oneYear.getDate() - 365)
    var oneYearInput = oneYear.toISOString()
    if (QualityPlans && user) {
      for (var q = 0; q < QualityPlans.length; q++) {
        if (user.role === 'admin') {
          if (QualityPlans[q].form_values['5e22'] >= oneYearInput && QualityPlans[q].latitude !== null) {
            setData([...data, QualityPlans[q]])
          }
        } else if (user.role === 'client') {
          if (
            QualityPlans[q].form_values['6f71'] === user.username &&
            QualityPlans[q].form_values['5e22'] >= oneYearInput &&
            QualityPlans[q].latitude !== null
          ) {
            setData([...data, QualityPlans[q]])
          }
        }
      }
    }
  }, [QualityPlans, user])

  if (user && user.role === 'maintenance') {
    return <Redirect to='/maintenance' />
  }
  let sortedPosts = postData.sort((a, b) => new Date(b.form_values['b6e0']) - new Date(a.form_values['b6e0']))
  return (
    <div>
      {clientEnquiry()}
      <h2>Admin Posts / Updates</h2>
      <Table
        pagination={{ position: 'bottom', pageSize: 4 }}
        bordered
        id='postTable'
        loading={checkData()}
        className='tableResizer'
        columns={columns.POSTS}
        dataSource={sortedPosts}
        rowKey={r => r.id}
        size='middle'
      />

      <MapWithAMarker
        googleMapURL='https://maps.googleapis.com/maps/api/js?key=AIzaSyALSdb8pDixxuFtKtAHTfss_cW7bvI6IOY&v=3.exp&libraries=geometry,drawing,places'
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={
          <div
            style={{
              height: `380px`,
              border: '1px solid #e8e8e8',
              borderRadius: '4px'
            }}
          />
        }
        mapElement={<div style={{ height: `100%` }} />}
        QualityPlans={data}
      />
    </div>
  )
}
export default Home
